import { Action } from '@ngrx/store';
import { Markets } from '@models/markets';
import { MarketDetails } from '@models/marketDetail';
import { MarketFilter } from '@models/marketFilter';

export enum EnumMarketActions {
    SetMarket = '[Markets] Setting markets',
    GetMarket = '[Markets] Get markets',
    GetMarketFailed = '[Markets] Get markets failed',
    SetMarketHome = '[Markets] Setting markets home',
    GetMarketHome = '[Markets] Get markets home',
    GetMarketHomeFailed = '[Markets] Get markets home failed',
    GetMarketDetails = '[Market] Get market details',
    SetMarketDetails = '[Market] Setting market details',
    SetMarketFilter = '[MarketFilter] Setting marker',
    FillMarkets = '[Markets] Fill market list with favorites and alerts',
    RefreshMarkets = '[Markets] Refresh market list on store'
}

export class SetMarket implements Action {
    public readonly type = EnumMarketActions.SetMarket;
    constructor(public markets: Markets[]) {}
}

export class GetMarket implements Action {
    public readonly type = EnumMarketActions.GetMarket;
}

export class GetMarketFailed implements Action {
    public readonly type = EnumMarketActions.GetMarketFailed;
}

export class SetMarketHome implements Action {
    public readonly type = EnumMarketActions.SetMarketHome;
    constructor(public markets: Markets[]) {}
}

export class GetMarketHome implements Action {
    public readonly type = EnumMarketActions.GetMarketHome;
}

export class GetMarketHomeFailed implements Action {
    public readonly type = EnumMarketActions.GetMarketHomeFailed;
}

export class GetMarketDetails implements Action {
    public readonly type = EnumMarketActions.GetMarketDetails;
}

export class SetMarketDetails implements Action {
    public readonly type = EnumMarketActions.SetMarketDetails;
    constructor(public marketDetails: MarketDetails[]) {}
}

export class SetMarketFilter implements Action {
    public readonly type = EnumMarketActions.SetMarketFilter;
    constructor(public marketFilters: MarketFilter[]) {}
}

export class FillMarkets implements Action {
    public readonly type = EnumMarketActions.FillMarkets;
}

export class RefreshMarkets implements Action {
    public readonly type = EnumMarketActions.RefreshMarkets;
}

export type MarketActions = SetMarket
                          | GetMarket
                          | GetMarketFailed
                          | SetMarketHome
                          | GetMarketHome
                          | GetMarketHomeFailed
                          | SetMarketDetails
                          | SetMarketFilter
                          | FillMarkets
                          | RefreshMarkets;
